import { render, staticRenderFns } from "./CList.vue?vue&type=template&id=810a3cb4&"
import script from "./CList.vue?vue&type=script&lang=ts&"
export * from "./CList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports